// ForgotPassword.jsx (MUI version)
import React, { useState } from "react";
import apiClient from "api/apiClient";
import { Link, useNavigate } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import "scenes/login/login.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("info");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage("");
    try {
      const { data } = await apiClient.post(
        `${process.env.REACT_APP_BASE_URL}/user/forgot-password`,
        { email },
      );
      setSeverity("success");
      setMessage(data.message || "If the email exists, a reset link was sent.");
    } catch (err) {
      setSeverity("error");
      setMessage(
        err?.response?.data?.message || "An error occurred. Please try again.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box className="login-wrapper">
      <section className="login-shell">
        <aside className="login-sidebar">
          <div className="login-sidebar-inner">
            <div className="login-brand-block">
              <div className="login-brand-logo">
                <img src="/images/PGL_Logo-removebg-preview.png" alt="PGL Logo" className="logo" />
              </div>
              <p className="login-brand-eyebrow">Planète GreenLeaves (PGL)</p>
            </div>

            <div className="login-message-block">
              <h1>City-scale climate and energy intelligence for better urban decisions.</h1>
            </div>
          </div>
        </aside>

        <main className="login-main">
          <Paper elevation={6} className="login-container">
            <Typography variant="h5" align="center" sx={{ mb: 2, color: "black" }}>
              Forgot Password
            </Typography>

            {message ? (
              <Alert severity={severity} sx={{ mb: 2 }}>
                {message}
              </Alert>
            ) : null}

            <Box component="form" onSubmit={handleSubmit} noValidate>
              <Stack spacing={2}>
                <TextField
                  id="email"
                  name="email"
                  type="email"
                  label="Email"
                  placeholder="you@company.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  fullWidth
                  autoComplete="email"
                />

                <Button type="submit" variant="contained" size="large" disabled={submitting} fullWidth>
                  {submitting ? "Sending..." : "Send Reset Link"}
                </Button>

                <Button
                  component={Link}
                  to="/login"
                  variant="outlined"
                  size="large"
                  fullWidth
                  sx={{ textTransform: "none" }}
                >
                  Go to Login
                </Button>
              </Stack>
            </Box>
          </Paper>
        </main>
      </section>
    </Box>
  );
};

export default ForgotPassword;
